// packages
import React, { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useSelector, useDispatch } from "react-redux";

// Import Columns
import {
  engaged_20 as engaged20
} from "../ClientData/actions";

//import components
import { ChangeInitial } from "../../redux/Main/action";
import ClientChoose from "../Clients/chooseClient";
import DynamicCards from "../Shared/DynamicCards";

const EngagedSession = () => {

  const dispatch = useDispatch();
  const { isAuthenticated } = useAuth0();
  const { role, client } = useSelector(({ main }) => main);

  useEffect(() => {
    dispatch(ChangeInitial("Engaged Sessions"));
  }, [dispatch]);

  return (
    <div className="container-fluid">
      {isAuthenticated && role === "admin" && (
        <ClientChoose alertType="alert alert-success">
          <span>
            Welcome <strong>Team Member</strong>. Please choose a client to
            view/edit their data.
          </span>
        </ClientChoose>
      )}
      {client !== "NONE" && (
        <div className="dashboard dynamic-card">

          {/* Engaged 20 Card */}
          <DynamicCards
            title="Engaged 20"
            formType="engaged_20"
            background="linear-gradient(60deg, rgb(255, 200, 69), rgb(255, 158, 27))"
            // background="linear-gradient(60deg, rgb(0, 147, 178), rgb(0, 97, 127))"
            headerIcon="face"
            columns={engaged20}
            card={["Person", "Device"]}
          />

        </div>
      )}
    </div>
  );
};

export default EngagedSession;